// 「현장 사진에서 고르기」 후보를 기록 날짜별로 묶는다 — 날짜는 최근 먼저, 날짜 안의 순서는 받은 그대로.
export interface PhotoDateGroup<T> {
  date: string;
  photos: T[];
}

export const photoGroupsByDate = <T extends { log_date?: string }>(photos: readonly T[]): PhotoDateGroup<T>[] => {
  const groups = new Map<string, T[]>();
  for (const photo of photos) {
    const date = photo.log_date ?? "";
    const list = groups.get(date);
    if (list) list.push(photo);
    else groups.set(date, [photo]);
  }
  return [...groups.entries()]
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([date, list]) => ({ date, photos: list }));
};

// 「안 고른 사진만」 — 이미 장에 넣은 현장 사진을 빼고 남은 후보.
export const unpickedPhotos = <T extends { id: string }>(
  photos: readonly T[],
  pickedIds: ReadonlySet<string>
): T[] => photos.filter((photo) => !pickedIds.has(photo.id));
